import { createFileRoute } from "@tanstack/react-router";
import { TeammatesPage } from "../../../components/teammates/teammates-page";

/** Every teammate of the workspace, and what each one owns (Paper TM1, ENG-1038). */
export const Route = createFileRoute("/_authenticated/_workspace/teammates/")({
  component: TeammatesPage,
});
